import FundsList from './FundsList'
import FundDetail from './FundDetail'
import FundsWatchList from './FundsWatchList'
import DividendRecords from './DividendRecords'
import Compare from './Compare'

const RouterConfig = {
  routes: [
    {
      isRedirect: true,
      exact: true,
      from: '/',
      to: '/funds'
    },
    {
      url: '/funds',
      component: FundsList,
      exact: true,
      alias: 'Fund List'
    },
    {
      url: '/funds/watchlist',
      component: FundsWatchList,
      exact: true,
      alias: 'WatchList'
    },
    {
      url: '/funds/dividendRecords',
      component: DividendRecords,
      exact: true,
      alias: 'Dividend Records'
    },
    {
      url: '/funds/compare',
      component: Compare,
      exact: true,
      alias: 'Compare'
    },
    {
      url: '/funds/:id',
      component: FundDetail,
      exact: true,
      alias: 'Fund Detail'
    },
    {
      url: '/funds/:id/:tabName',
      component: FundDetail,
      exact: true,
      alias: 'Fund Detail'
    }
  ]
}

export default RouterConfig
